const damTokenErrorTypes = {
    AP_TOKEN_IS_REVOKED: 'AP_TOKEN_IS_REVOKED',
};

export default damTokenErrorTypes;
